import React from 'react';
import PropTypes from 'prop-types';

import {
    Field,
} from 'redux-form';

const TextField = (props) => {
    const {
        input,
        meta: {
            touched,
            error,
        },
        label,
        type,
    } = props;

    return (
        <label className="form-item" htmlFor={input.name}>
            <span className="form-item__label">
                {label}
            </span>
            <input
                className="form-item__field"
                type={type}
                {...input}
            />
            {touched && error && (
                <div className="form-item__error">{error[0]}</div>
            )}
        </label>
    );
};

TextField.propTypes = {
    ...Field.props,
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
};

TextField.defaultProps = {
    type: 'text',
};

export default TextField;



// WEBPACK FOOTER //
// ./resources/components/forms/components/TextField.jsx